// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

import ratios from 'Components/utils/ratios/ratios.utils';

import Image from 'Components/frameworks/image/Image.jsx';
import { ImageSlideShow } from 'Components/frameworks/image-slideshow/ImageSlideShow.jsx';

type Props = {
  children: Node,
  className?: string,
  hasInsetBorder?: boolean,
  isActive?: boolean,
  media: Array<{
    alt?: string,
    src: string,
  }>,
  nextLabel?: string,
  previousLabel?: string,
  ratio?: string,
  width?: number,
};

export function TeaserCard(props: Props) {
  const {
    children,
    className,
    hasInsetBorder,
    isActive,
    media = [],
    nextLabel,
    previousLabel,
    ratio = ratios.R_38_BY_28,
    width,
  } = props;

  const defaultPicture = media[0] || {};

  return (
    <div className={classnames(className, 'flex flex-col')} style={{ width }}>
      {children}
      <div
        className={classnames(
          'bg-gray-darker rounded-tiny -order-1 overflow-hidden transition-all image-responsive-cell',
          {
            'opacity-75 scale-095': isActive,
          },
        )}
      >
        {media.length > 1 ? (
          <ImageSlideShow
            hasControlsOnHover
            hasInsetBorder={hasInsetBorder}
            hasLazyLoading
            media={media}
            nextLabel={nextLabel}
            previousLabel={previousLabel}
            ratio={ratio}
          />
        ) : (
          <Image
            altMsg={defaultPicture.alt}
            className={hasInsetBorder ? 'inset-border-after' : ''}
            groupKey="thumbnails"
            hasLazyLoading
            imageUrl={defaultPicture.src}
            key={defaultPicture.src}
            ratioKey={ratio}
          />
        )}
      </div>
    </div>
  );
}
